module.exports = __webpack_public_path__ + "static/media/tenant5-1.96a6377b.png";